import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

export const LoadingSpinner = ({ isLoading = true, modalMode = false }) => {
	return (
		<Flex height={'100%'} paddingTop={'10%'}>
			<Spinner
				width={modalMode ? '50px' : '100px'}
				height={modalMode ? '50px' : '100px'}
				thickness="5px"
				speed="0.65s"
				emptyColor="gray"
				color="green"
				size="xl"
			/>
		</Flex>
	);
};

export default LoadingSpinner;
